import firebase from "firebase/app";
import 'firebase/firestore'
import "firebase/auth";
import 'firebase/storage'


let firebaseConfig = {
    apiKey: "AIzaSyBST9sIMaeJDvCyBTOb2SdiEDiS2DCd_Wc",
    authDomain: "chamados-e6a22.firebaseapp.com",
    projectId: "chamados-e6a22",
    storageBucket: "chamados-e6a22.appspot.com",
    messagingSenderId: "210135908735",
    appId: "1:210135908735:web:25f93b99bb70e467cfda4a",
    measurementId: "G-T4XF1C25K8"
  };
  
  // Initialize Firebase
  
  if(!firebase.apps.length){
    firebase.initializeApp(firebaseConfig);
}

export default firebase;